<template lang="pug">
  .abilityGroup
    p.abilityGroup__title 派遣與排班站管理
    .abilityGroup__item
      span.abilityGroup__subtitle 派遣區域
      BaseAbilityRadioGroup(
        :value="abilityDispatchArea"
        :disabled="disabled"
        @handleRadioChange="setAbilityDispatchArea")
    .abilityGroup__item
      span.abilityGroup__subtitle 排班站區域
      BaseAbilityRadioGroup(
        :value="abilityScheduledArea"
        :disabled="disabled"
        @handleRadioChange="setAbilityScheduledArea")
    .abilityGroup__item
      span.abilityGroup__subtitle 排班站看板
      BaseAbilityRadioGroup(
        :value="abilityScheduledBoard"
        :disabled="disabled"
        @handleRadioChange="setAbilityScheduledBoard")
</template>
<script>
import BaseAbilityRadioGroup from '@/components/common/select/BaseAbilityRadioGroup'
import { mapGetters, mapActions } from 'vuex'

export default {
  props: {
    disabled: {
      type: Boolean,
      required: false,
      default: true,
    },
  },
  computed: {
    ...mapGetters({
      abilityDispatchArea: 'positionStore/getCurrentAbilityDispatchArea',
      abilityScheduledArea: 'positionStore/getCurrentAbilityScheduledArea',
      abilityScheduledBoard: 'positionStore/getCurrentAbilityScheduledBoard',
    }),
  },
  methods: {
    ...mapActions({
      setAbilityDispatchArea: 'positionStore/setAbilityDispatchArea',
      setAbilityScheduledArea: 'positionStore/setAbilityScheduledArea',
      setAbilityScheduledBoard: 'positionStore/setAbilityScheduledBoard',
    }),
  },
  components: {
    BaseAbilityRadioGroup,
  },
}
</script>
<style lang="scss" scoped>
@import 'src/scss/_abilityGroup';
</style>



// WEBPACK FOOTER //
// src/pages/manager/AbilityRadioGroup/AbilityGroupDispatchItems.vue